import React from 'react';
import PropTypes from 'prop-types';
const expandIcon = 'fas fa-plus toggleExpand';
const collapseIcon = 'fas fa-minus toggleExpand';
const ExpandCollapse = ({
  expanded,
  onClick
}) => {
  const expand = event => {
    event.stopPropagation();
    onClick(!expanded);
  };
  if (expanded) {
    return /*#__PURE__*/React.createElement("span", {
      onKeyDown: expand,
      style: {
        marginRight: '5px'
      },
      role: "link",
      tabIndex: 0,
      className: `t-tn-collapse ${collapseIcon}`,
      onClick: expand,
      "aria-label": "collapse"
    });
  }
  return /*#__PURE__*/React.createElement("span", {
    onKeyDown: expand,
    style: {
      marginRight: '5px'
    },
    role: "link",
    tabIndex: 0,
    className: `${expandIcon} t-tn-expand`,
    onClick: expand,
    "aria-label": "expand"
  });
};
ExpandCollapse.propTypes = {
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired
};
export default ExpandCollapse;